import { GetTaskParams } from "./task.types";

export const TASK_KEYS = {
  TASKS: "TASKS",
  GET_TASKS: (params: GetTaskParams) => [TASK_KEYS.TASKS, params],
  GET_TASK: (taskId?: string) => [TASK_KEYS.TASKS, taskId],
  GET_MOST_URGENT_TASKS: () => [TASK_KEYS.TASKS],
  GET_TASKS_FOR_DATE: (startDate: string, endDate: string) => [
    TASK_KEYS.TASKS,
    "BY_DATE",
    startDate,
    endDate,
  ],
};
